<template>
  <div class="form-flex">
    <drop>
      <button :data-label="$t('bulkActions.label')" class="hint hint--right btn btn--lg  btn--default" slot="trigger">
        <i v-bind:class="icon"></i>
      </button>
      <drop-content slot="content">
        <ul class="c-nav c-nav--menus">
          <li class="c-nav__item" v-for="action in actions" :key="action">
            <a role="button" class="c-nav__link" @click="onChangeBulk(action.value, action.module)">{{ $t(`${action.label}.label`)}}</a>
          </li>
        </ul>
      </drop-content>
    </drop>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import notifier from '@/notifier'

  export default {
    data: () => ({
      value: ''
    }),
    props: {
      actions: {
        type: Array,
        required: true
      },
      icon: {
        type: String,
        required: true
      }
    },
    created () {
      let actionsTmp = []
      for (let i in this.actions) {
        const action = this.actions[i]

        const module = this.modulesInstalled.find(
          moduleInstalled => moduleInstalled.type === action.module.type && moduleInstalled.identifier === action.module.identifier
        )

        if (module !== undefined) {
          actionsTmp.push(action)
        }
      }

      this.actions.splice(0, this.actions.length)

      for (let i in actionsTmp) {
        this.actions.push(actionsTmp[i])
      }
    },
    methods: {
      onChangeBulk (value, module) {
        this.value = value
        if (!this.itemsSelectedTotalSelected) {
          this.value = ''
          notifier.warning('Por favor selecione algum item para seguir com a ação.', 'Atenção')
          return false
        }

        if (this.canApply()) {
          this.$emit('apply', this.value, module)
        }
      },
      canApply () {
        return this.value !== ''
      }
    },
    computed: {
      ...mapFields({
        itemsSelectedTotalSelected: 'itemsSelected.totalSelected'
      }),
      ...mapGetters('module', [
        'definitionModulesInstalled'
      ]),
      modulesInstalled () {
        return this.definitionModulesInstalled
      }
    }
  }
</script>
<style scoped lang="sass">
  i
    color: #7872ff

  .btn--default
    margin-right: 5px
</style>



// WEBPACK FOOTER //
// BulkActions.vue?77a67e86